import Image from "next/legacy/image";
import Link from "@/utils/link";

import HomeHeader from "@/components/home/HomeHeader";
import SeoLinks from "@/components/home/SeoLinks";
import HomeFooter from "@/components/home/HomeFooter";

import GetStartedAccount from "../Logo/GetStartedAccount";
import GetStartedExplore from "../Logo/GetStartedExplore";
import GetStartedHome from "../Logo/GetStartedHome";

import { imageLoader } from "@/utils/image";
import Button from "@/ui/Button";

const GetStarted = () => {
    return (
        <div className="relative h-screen">
            <HomeHeader fixed />

            <div className="relative">
                <div className="sm:hidden relative w-full h-72">
                    <Image
                        loader={imageLoader}
                        src="https://cdn.purpledoorfinders.com/purpledoorfinders/purpledoorfinders-about-us"
                        alt="about us"
                        layout="fill"
                        objectFit="cover"
                        objectPosition="left top"
                        priority
                        unoptimized={false}
                        className=""
                    />
                </div>

                <div className="container mx-auto px-8 sm:px-16">
                    <div className="w-full sm:w-1/2 pt-8 sm:pt-32 pr-8 min-h-[600px]">
                        <h2 className="text-gray-sec text-2xl font-bold tracking-normal font-headline uppercase">
                            For Seniors + Their Families
                        </h2>
                        <h1 className="mt-2 text-primary-500 text-4xl font-bold tracking-normal font-headline">
                            Get Started
                        </h1>

                        <p className="mt-12 pb-8 text-lg">
                            Your search for senior living options is easy with Purple Door
                            Finders, We put your needs first with easy search features,
                            informative tools, and the most complete listings of senior
                            living options available—and it’s all FREE to seniors and their
                            families.
                        </p>

                        <div className="mt-8">
                            <Button className="w-48" size="xl" href="/create-account">
                                Create Account
                            </Button>
                        </div>
                    </div>
                </div>

                <div className="hidden sm:block absolute top-0 left-1/2 right-0 bottom-0">
                    <Image
                        loader={imageLoader}
                        src="https://cdn.purpledoorfinders.com/purpledoorfinders/purpledoorfinders-about-us"
                        alt="about us"
                        layout="fill"
                        objectFit="cover"
                        objectPosition="left top"
                        priority
                        unoptimized={false}
                        className=""
                    />
                </div>
            </div>

            <div className="bg-gray-light">
                <div className="container mx-auto px-8 sm:px-16">
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-x-16 py-16">
                        <Card
                            index="1"
                            title="Create Account"
                            Logo={GetStartedAccount}
                            href="/create-account"
                        >
                            Start your FREE account to access tools and save your search
                            results and manage your senior living search.
                        </Card>

                        <Card
                            index="2"
                            title="Explore Assisted Living Tools"
                            Logo={GetStartedExplore}
                            href="/resources"
                        >
                            Complete your assessment, financial calculator, and timeline as
                            well use our guidebooks and checklists to learn what senior
                            living options are best for you.
                        </Card>

                        <Card
                            index="3"
                            title="Find Communities"
                            Logo={GetStartedHome}
                            href="/favorites"
                        >
                            Start your search and connect directly with senior living
                            communities that fit your needs.
                        </Card>
                    </div>
                </div>
            </div>

            <div className="container mx-auto px-8 sm:px-16">
                <div className="py-16 text-center">
                    <h3 className="text-primary-500 text-4xl font-headline font-bold">
                        Have More Questions?
                    </h3>

                    <div className="mt-8 flex justify-center space-x-16">
                        <Button size="lg" href="/resources/faq">
                            FAQs
                        </Button>
                        <Button size="lg" href="/resources">
                            Resources
                        </Button>
                        <Button size="lg" href="/help">
                            Help
                        </Button>
                    </div>
                </div>
            </div>

            <SeoLinks />
            <HomeFooter />
        </div>
    );
};

const Card = ({ index, title, children, Logo, href = "/" }) => {
    return (
        <Link href={href}>
            <a className="flex flex-col items-center text-center">
                <div className="relative">
                    <div className="absolute top-4 -left-16 text-6xl text-gray-500">
                        {index}
                    </div>
                    <Logo />
                </div>

                <h3 className="mt-8 h-20 text-primary-500 text-3xl font-headline font-bold uppercase">
                    {title}
                </h3>

                <p className="text-lg">{children}</p>
            </a>
        </Link>
    );
};

export default GetStarted;
